import { Injectable, Output, EventEmitter } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { ILayoutManager, Layout, OnLayoutChanged } from './layout-manager';

import { RoomManagerService } from '../room/room-manager.service';
import { MediaManagerService } from '../media/media-manager.service';
import { LayoutParserService } from './layout-parser.service';
import { WsService2 } from '../ws/ws.service';

import { WbService } from '../../../wb/wb.service';
declare var $;
@Injectable()
export class LayoutManagerService implements ILayoutManager {
    callbacks = [];
    tumbClicked() {
        this.setFullscreen();
    }
    registerLayoutChangedCallback(callback: OnLayoutChanged) {
        this.callbacks.push(callback);
    }

    constructor(private roomManagerService: RoomManagerService,
        private parser: LayoutParserService, private wbService: WbService, private ws: WsService2,
        private mediaManager: MediaManagerService) {
        parser.setManager(this);
        roomManagerService.registerCallback(this);
        mediaManager.setLayoutManager(this);
    }
    detached
    isFullScreen = false;
    setFullscreen() {
        this.parser.sendFullscreen(!this.isFullScreen);
    }

    onPeer(peer) {

        console.log("Got new peer, will check the layout to resize it");
        if (this.isFullScreen) {
            console.log('it is fullscreen')
            setTimeout(() => {
                $(".peers-wrapper .dskl-peer").addClass('full');

                if (Object.keys(this.roomManagerService.peers).length == 2) {
                    $(".peers-wrapper .dskl-peer").not('.me').addClass('single')
                } else {
                    $(".peers-wrapper .dskl-peer").not('.me').removeClass('single')
                }
            }, 1000)


        } else {
            $("#peerscontainer").removeClass('full');
        }
    }
    onFullscreen(to) {
        this.isFullScreen = to;
        if (to) {


            $(".peers-wrapper").addClass('full-videos')
            $(".peers-wrapper .dskl-peer").addClass('full');
            $("#peerscontainer").addClass('full-videos');
            this.detached = $("#videoConversation").addClass('full-videos-button').detach();
            $("#peerscontainer").append(this.detached);
            //this.isFullVideo = true;
            if (Object.keys(this.roomManagerService.peers).length == 2) {
                $(".peers-wrapper .dskl-peer").not('.me').addClass('single')
            }

        } else {

            $(".peers-wrapper").removeClass('full-videos')
            $(".peers-wrapper .dskl-peer").removeClass('full').removeClass('single');
            $("#peerscontainer").removeClass('full-videos');
            $("#videoConversation").removeClass('full-videos-button')
            this.detached = $("#videoConversation").removeClass('full-videos-button').detach();
            $("#wb-status").prepend(this.detached)
        }
        this.wbService.onResize()

    }
    layout: Layout = Layout.VIDEOS_WB;
    onLayout(layout) {
        this.setLayout(layout, true);
    }
    sendResize(to) {
        this.parser.sendResize(to);
    }
    resize() {
        this.wbService.onResize();
    }
    updateLayout() {

        this.switchLayouts(this.layout);
    }

    private setLayout(layout, notify) {
        switch (layout) {
            case "VIDEOS_WB": this.layout = Layout.VIDEOS_WB; break;
            case "AUDIO_WB": this.layout = Layout.AUDIO_WB; break;
            case "TEACHER_PRESENTATION_BOTH": this.layout = Layout.TEACHER_PRESENTATION_BOTH; break;
            case "TEACHER_PRESENTATION_AUDIO": this.layout = Layout.TEACHER_PRESENTATION_AUDIO; break;
            case "NONE": this.layout = Layout.NONE; break;
            case "AUDIO_SNAPSHOTS": this.layout = Layout.AUDIO_SNAPSHOTS; break;
        }
        this.switchLayouts(layout);
        for (let c of this.callbacks)
            c.layoutChanged(this.layout);
        if (notify)
            this.parser.sendLayoutChanged(Layout[this.layout]);
       
    }
    snapshotCanvas;
    snapshotCanvasContext;
    stopSnapshots() {

        if (this.snapshotInterval)
            try {
                clearInterval(this.snapshotInterval);
            } catch (error) { }
    }
    setSnapshotCanvas() {
        this.snapshotCanvas = document.createElement('canvas');
        this.snapshotCanvas.width = 272;
        this.snapshotCanvas.height = 120;
        this.snapshotCanvasContext = this.snapshotCanvas.getContext('2d');
        // if (this.isSnapshotLayout) {
        this.stopSnapshots();
        this.snapshotInterval = setInterval(this.snapshot.bind(this), 2000)
        //}
    }
    snapshotInterval;
    snapshot() {
        // if (this.peer.me) {
        this.snapshotCanvasContext.clearRect(0, 0, this.snapshotCanvas.width, this.snapshotCanvas.height);
        this.snapshotCanvasContext.drawImage($("#video-" + this.ws.getMe())[0], 0, 0, this.snapshotCanvas.width, this.snapshotCanvas.height);
       
        this.mediaManager.sendVideoSnapshot(this.snapshotCanvas.toDataURL('image/jpeg', 0.3))
        // }
    }
    isSnapshotsLayout() {
        return this.layout == Layout.AUDIO_SNAPSHOTS;
    }
    switchLayouts(layout) {
        if (!$("#rowwb") || $("#rowwb").length == 0) return;
        var rowb = $("#rowwb").detach();
       
        switch (layout) {
            case Layout.AUDIO_WB:
            case Layout.TEACHER_PRESENTATION_AUDIO:
            case Layout.TEACHER_PRESENTATION_BOTH:
            case Layout.NONE:
               
                $("#videos").parent().prepend(rowb);
                break;
            default: 
            if (!environment.color)
                $("#videos").parent().prepend(rowb);
            else
                $("#videos").parent().append(rowb); break;

        } if (!environment.color){
            
        //if (layout==Layout.AUDIO_WB){
            $('#peers').css('background', "url('"+environment.logo+"') 0px 42px/contain no-repeat");
        /*}else{
            $('#peers').css('background', "none");
        }*/
        }/*
        if (layout == Layout.VIDEOS_WB || layout == Layout.AUDIO_SNAPSHOTS){

            $(".status-mts").css("margin-top", "0px")
          }else{
              if (!environment.color){
                    $(".status-mts").css("margin-top", "30px")
              }else{
                    $(".status-mts").css("margin-top", "0px")
              }
          }*/
        /*
        if (layout == Layout.AUDIO_SNAPSHOTS) {
            this.setSnapshotCanvas();
        } else {
            this.stopSnapshots();
        }*/
        var self = this;
        setTimeout(function () {
            self.resize();
        }, 200);

    }
    getLayout(): Layout {
        return this.layout;
    }
    changeLayout(layout) {
        this.parser.sendChangeLayout(layout);
    }
    isVideosWb() {
        if (!environment.color){
            return false;
            
        }else
        return this.layout == Layout.VIDEOS_WB || this.layout == Layout.AUDIO_SNAPSHOTS;
    }
    isAudiosWb() { 
        if (!environment.color){
            return true;
        }
        switch (this.layout) {
            case Layout.AUDIO_WB:
            case Layout.TEACHER_PRESENTATION_AUDIO:
            case Layout.TEACHER_PRESENTATION_BOTH:
            case Layout.NONE:
                return true;

            default: return false;
        }
    }
    onInitalLayout(layout) {
        this.setLayout(layout, false);
    }

    public hideVideos = new EventEmitter()
    onHideVideos() {
        this.hideVideos.emit()
    }
    setCurrentColor(color) {
        this.color = color;
    }
    color = "white";
    getCurrentColor() {
        return this.color;
    }
}



// WEBPACK FOOTER //
// /app/src/app/wb/services/layout/layout-manager.service.ts